export enum AssetListType {
    AvailableAsset = "Available Assets",
    ProjectAsset = "Project Assets",
}